#import "~/graphql/fragments/assets/image.graphql"

fragment socialFragment on Ether_SeoData {
    title
    description
    social {
        twitter {
            title
            description
            image {
                ... image
            }
        }
        facebook {
            title
            description
            image {
                ... image
            }
        }
    }
    advanced {
        robots,
        canonical
    }
}
